export const EXPERIENCE_TYPES = ['unified', 'classic', 'fullpage'];

export function isExperienceType(value) {
  return EXPERIENCE_TYPES.includes(value);
}

export function normalizeExperienceType(value) {
  return isExperienceType(value) ? value : undefined;
}
